import React, { useRef } from "react"
import Dropzone from "react-dropzone"
import { FaDownload } from 'react-icons/fa'
import { Modal } from 'rsuite';
import { downloadFileFromS3Bucket } from '../../../redux/actions/vendor'
import { toast } from '../../CommonComponents/ToastComponent/toast'
import { useDispatch } from 'react-redux'

const DragDropFileUpload = ({
  onChangeMessage, onFileChosen,
  currentFileName, message = "",
  progress = 0, loadData, customClassName = '',
  accept = '',
  showProgress = false,
  isDisabled = false,
  isDownload = false,
  imageURL = '',
  ...props
}) => {

  const handleDrop = (files) => {
    if (files.length > 0) {
      onFileChosen(files[0])
    }
  }
  const dispatch = useDispatch()
  const myRefname = useRef(null);
  const [openModal, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const onClickDownload = (event) => {
    if (isDownload) {
      event.stopPropagation()
      handleOpen()
    }
  }

  const handleModalUploadClick = (myRefname) => {
    myRefname.current.click()
    handleClose()
  }

  const handleModalDownloadClick = () => {
    dispatch(
      downloadFileFromS3Bucket({ filename: currentFileName })
    ).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", currentFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.show({
        title: 'Success',
        description: currentFileName + ' downloaded successfully!',
      })
      handleClose()
    }).catch(() => {
      toast.show({
        title: 'Warning',
        description: "Unable to Download File!",
      })
    })
  }

  return (
    <>
      <div>
        {showProgress && currentFileName && (
          <div className="progress mb-3">
            <div
              className="progress-bar progress-bar-info progress-bar-striped"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: progress + "%" }}
            >
              {progress}%
            </div>
          </div>
        )}

        <Dropzone onDrop={handleDrop} multiple={false} disabled={isDisabled}>
          {({ getRootProps, getInputProps }) => (
            <section className={customClassName}>
              <div {...getRootProps({ className: "dropzone file-upload-dropzone", onClick: event => isDownload ? onClickDownload(event) : myRefname.current.click() })}>
                <input
                  {...getInputProps()}
                  accept={accept || '.csv, .xls, .xlsx'}
                  onChange={e => onFileChosen(e.target.files[0])}
                  ref={myRefname}
                />
                {currentFileName && currentFileName !== '' ? (
                  <div className={`selected-file h4 text-center text-black${imageURL ? ' w-100 d-flex flex-column gap-2 align-items-center' : ''}`}>
                    {imageURL && (
                      <img src={imageURL} className="image w-auto h-auto"/>
                    )}
                    {currentFileName}
                  </div>
                ) : (
                  <div className="dropzone-custom-message">
                    <h4 className="drag-drop-text fw-bold">Drag and Drop your files here, or </h4>
                    <h4 className="browse-file-text fw-bold"> Browse from computer </h4>
                  </div>
                )}
                {isDownload && (
                  <FaDownload
                    className="download-file"
                    color="#65B3E9"
                    size={20}
                  />
                )}
              </div>
            </section>
          )}
        </Dropzone>

        <div className={`alert alert-light ${message ? 'd-block' : 'd-none'}`} role="alert">
          {message}
        </div>
      </div>
      {openModal && (
        <Modal
          backdrop={true}
          className="download-file-modal"
          show={openModal}
          size="sm"
          onHide={handleClose}
        >
          <Modal.Header>
            <h3 className="mb-0 fw-bold">Download File</h3>
          </Modal.Header>
          <Modal.Body className='download-file-modal-body'>
            Do you want to Download File or upload new file?
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="modal-download-button" onClick={handleModalDownloadClick}><h5 class="mb-0"> Download </h5></button>
            <button type="button" className="modal-upload-button" onClick={() => handleModalUploadClick(myRefname)}><h5 class="mb-0"> Upload </h5></button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}

export default DragDropFileUpload